import { Injectable } from '@angular/core';
import { ChatThreadItem } from '@azure/communication-chat';
import { Subject } from 'rxjs';
import { NotificationService } from 'src/app/Service/notification.service';
import { UserService } from 'src/app/User/Service/user.service';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  chatClient;
  newMessage$: Subject<any> = new Subject();
  newMessages = [];
  constructor(private notify: NotificationService, private user: UserService) {}
  async setupHandlers() {
    await this.chatClient.startRealtimeNotifications();
    this.chatClient.on(
      'chatMessageReceived',
      ((state: any) => {
        if (!this.newMessages.find((i) => i.id == state.id)) {
          this.newMessage$.next(state);
          if (
            this.user?.userInfo?.acsIdentity !=
            state?.sender?.communicationUserId
          ) {
            this.notify.showInfo(
              'New message received from ' + state.senderDisplayName
            );
            this.newMessages.push(state);
          }
        }
      }).bind(this)
    );
    this.getAllThreads();
  }
  allThreats: ChatThreadItem[];
  async getAllThreads(forceRefresh = false) {
    if (this.allThreats?.length && !forceRefresh)
      return this.allThreats;
    this.allThreats = [];
    const listThreats = this.chatClient.listChatThreads();
    for await (const threats of listThreats) {
      if (!threats.deletedOn) this.allThreats.push(threats);
    }
    return this.allThreats;
  }
  async createChatThread(acsId, name, topic) {
    const createChatThreadResult = await this.chatClient.createChatThread(
      {
        topic,
      },
      {
        participants: [
          {
            id: {
              communicationUserId: acsId,
            },
            displayName: name,
          },
        ],
      }
    );
    this.allThreats.push(createChatThreadResult?.chatThread);
    return createChatThreadResult?.chatThread;
  }
}
